import ga4 from 'react-ga4';

export const Analytics = ga4;
